<template>
  <b-modal v-model="active" size="xl" :id="modalId">
    <div slot="modal-header" minimize class="app-modal-header">
      <span class="app-modal-header__icon"><AppIcon name="edit_note" /></span>
      <h5 class="app-modal-header__title">Apertura inicial</h5>
    </div>

    <b-row>
      <b-col md="3">
        <b-form-group label="Fecha de inicio" description="Desde acá empieza el control contable.">
          <b-form-input type="date" size="sm" v-model="form.date"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="9">
        <b-form-group label="Referencia">
          <b-form-input type="text" size="sm" v-model="form.reference"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="12" class="mb-2">
        <b-button size="sm" variant="outline-dark" @click="prefill()"><AppIcon name="playlist_add" class="mr-1" />Precargar cuentas</b-button>
        <small class="text-muted ml-2">Trae las cuentas de Activo al Debe y las de Pasivo y Patrimonio al Haber. Completá los importes: las que queden en cero no se guardan.</small>
      </b-col>
      <b-col md="12">
        <AccountingEntryBuilder
          :key="builderKey"
          typeDebe=""
          typeHaber=""
          :defaultDebe="defaultDebe"
          :defaultHaber="defaultHaber"
          :reference="form.reference"
          :date="form.date"
          :declared="declared"
          :amountTotal="0"
          validationMode="manual"
          :showConstructor="true"
          :editableAmounts="true"
          @getAsiento="form.detail = $event" />
      </b-col>
    </b-row>

    <div slot="modal-footer">
      <b-button variant="outline-secondary" class="mr-1" @click="active = false"><AppIcon name="close" class="mr-1" />Cancelar</b-button>
      <b-button variant="outline-dark" class="mr-1" @click="saveWithoutBalances()"><AppIcon name="event_available" class="mr-1" />Iniciar sin saldos</b-button>
      <b-button variant="dark" @click="save()"><AppIcon name="save" class="mr-1" />Guardar apertura</b-button>
    </div>
  </b-modal>
</template>
<script>
  import AccountingEntryBuilder from '@/components/inc/accounting/entries'
  import serviceAPI from '../services'
  import Error from '@/handler/error'
  import moment from 'moment'

  export default {
    components: {
      AccountingEntryBuilder,
    },
    props: {
      businessId: {
        type: Number,
        default: 0,
      },
      declared: {
        type: Boolean,
        default: null,
      },
    },
    data: () => {
      return {
        active: false,
        modalId: 'accounting-opening-form',
        builderKey: 0,
        defaultDebe: [],
        defaultHaber: [],
        form: {
          date: '',
          reference: '',
          detail: null,
        },
      }
    },
    methods: {
      open() {
        this.form.date = moment().format('YYYY-MM-DD')
        this.form.reference = 'Apertura inicial'
        this.form.detail = null
        this.defaultDebe = []
        this.defaultHaber = []
        this.builderKey++
        this.active = true
      },
      collectLeaves(accounts, result) {
        accounts.forEach(account => {
          const children = account.children_recurrent || account.children || []
          if(children.length) {
            this.collectLeaves(children, result)
          } else {
            result.push(account)
          }
        })
      },
      prefill() {
        serviceAPI.filtrarPlanCuenta()
        .then(response => {
          const leaves = []
          this.collectLeaves(response.data || [], leaves)
          const rows = types => leaves
            .filter(account => account.active && types.includes(account.type))
            .map(account => ({ account: account, amount: 0 }))

          this.defaultDebe = rows(['Activo'])
          this.defaultHaber = rows(['Pasivo', 'Patrimonio'])
          this.form.detail = null
          this.builderKey++
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        })
      },
      save() {
        if(!this.form.date || !this.form.reference) {
          this.$awn.alert('Cargá la fecha y la referencia')
          return
        }
        if(!this.form.detail) {
          this.$awn.alert('El asiento tiene que tener importes y balancear')
          return
        }

        this.send({ detail: this.form.detail })
      },
      saveWithoutBalances() {
        if(!this.form.date || !this.form.reference) {
          this.$awn.alert('Cargá la fecha y la referencia')
          return
        }

        this.$bvModal.msgBoxConfirm('La contabilidad empieza el ' + moment(this.form.date).format('DD/MM/YYYY') + ' sin saldos iniciales: no se genera ningún importe. Si después necesitás cargarlos, editá la apertura en Movimientos Contables. ¿Continuar?', {
          title: 'Iniciar sin saldos',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'dark',
          okTitle: 'Iniciar',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          centered: true,
        })
        .then(value => {
          if(value) {
            this.send({ without_balances: true })
          }
        })
      },
      send(content) {
        let loader = this.$loading.show()
        serviceAPI.agregarAsiento(Object.assign({
          date: this.form.date,
          reference: this.form.reference,
          observations: '',
          origin: 'opening',
          business_id: this.businessId,
          declared: this.declared,
        }, content))
        .then(() => {
          loader.hide()
          this.active = false
          this.$awn.success('Apertura inicial guardada')
          this.$emit('saved')
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        })
      },
    }
  }
</script>
